import React, { Component } from 'react';
import { withRouter } from 'react-router';

class Pinput extends Component {
  constructor(props){
    super(props);
    this.state = {
      checked: false,
    };
    this.click=this.click.bind(this);
  }

  click(event){
  this.setState({ checked: !this.state.checked });
  this.props.click(event);
}

  render() {
    const {title, group, check} = this.props;
    return (
        <div>
          <label htmlFor={group} className={`main-buttons-label ${check === group ? 'label-click' : ''}`}>{title}</label>
          <input type="checkbox" name={group} value={group} className="user-inputs user-inputs-radio" id={group} onClick={this.click}/>
        </div>
    );
  }
}

export default withRouter(Pinput);



// WEBPACK FOOTER //
// ./src/routes/Paitent/Pinput.js